import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useAppointment = (appointmentId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["appointment", appointmentId, tenantVal],
    queryFn: async () => {
      if (!appointmentId) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/appointment/get/${appointmentId}`
      );
      return response.data;
    },
    enabled: !!appointmentId,
    meta: { errorMessage: "Error fetching appointment" },
  });
};
